export const COMMON_VALUES_EVENTS = {
  activity: 'UserTenantOnboarding-v01',
  screenPath: '/ReactUserTenantOnboarding/',
  version: '1.5.0'
};
